import { useSubmitted } from '@paradigm/features/src/forms/submitted-context';

import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import Select from '@paradigm/design-system/src/components/Select';
import { OptionTypeBase } from '@paradigm/design-system/src/components/Select/types';
import type { Props as BaseProps } from '@paradigm/design-system/src/components/Select';

export interface Props<OptionType extends OptionTypeBase>
  extends BaseProps<OptionType> {
  readonly invalid?: boolean;
  readonly width?: number | string;
}

export default function TransparentSelectField<
  OptionType extends OptionTypeBase,
>({ invalid = false, ...props }: Props<OptionType>) {
  const { didSubmit } = useSubmitted();
  const isMobile = useIsMobile();
  const width = isMobile ? '100%' : props.width;
  return (
    /* `submitted` is currently used for visually marking the field as invalid */
    <Select
      variant="transparent"
      placeholder="Select"
      submitted={didSubmit && invalid}
      width={width}
      {...props}
    />
  );
}
